import { USER } from "../actionType/socialAuthType";
import {
  authorizeToAzureForSignin,
  authorizeToAzureForSignup,
  authorizeToGmailForSignin,
  authorizeToGmailForSignup,
  connectToAzureForSignin,
  connectToAzureForSignup,
  connectToGmailForSignin,
  connectToGmailForSignup,
} from "../constant/Constant";
import { getMethod, postMethod } from "../services/HttpServices";

export const connectToMicrosoft365forSignup = (payload) => (dispatch) => {
  return postMethod(connectToAzureForSignup, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const connectToMicrosoft365forSignin = (payload) => (dispatch) => {
  return postMethod(connectToAzureForSignin, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const authorizeToMicrosoft365forSignup = (payload) => (dispatch) => {
  return getMethod(`${authorizeToAzureForSignup}?code=${payload}`, payload)
    .then((res) => {
      dispatch({
        type: USER,
        payload: res.data,
      });
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const authorizeToMicrosoft365forSignin = (payload) => (dispatch) => {
  return getMethod(`${authorizeToAzureForSignin}?code=${payload}`, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const connectToGoogleForSignup = (payload) => (dispatch) => {
  return postMethod(connectToGmailForSignup, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const connectToGoogleForSignin = (payload) => (dispatch) => {
  return postMethod(connectToGmailForSignin, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const authorizeToGoogleForSignup = (payload) => (dispatch) => {
  return getMethod(`${authorizeToGmailForSignup}?code=${payload}`, payload)
    .then((res) => {
      dispatch({
        type: USER,
        payload: res.data,
      });
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const authorizeToGoogleForSignin = (payload) => (dispatch) => {
  return getMethod(`${authorizeToGmailForSignin}?code=${payload}`, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
